export default __webpack_public_path__ + "locales/cs/PeopleTranslations.json?hash=0b40b13fb41ebc8ac52867457ea614f3";